<template>
  <ModalNewDesign :title="selectedMenuComponent.label" @close="closeModal">
    <div class="nd-body">
      <div class="nd-inr">
        <div class="lt-wrap pd-all-3">
          <template v-for="(item, itemIndex) in items" :key="`item_${itemIndex}`">
            <button
              v-if="isVisibleMenu(item)"
              type="button"
              :class="['inr-gray-btn', item.value === selectedMenu ? 'on' : '']"
              @click="handleMenu(item.value)"
            >
              {{ item.label }}
            </button>
          </template>
        </div>
        <div v-if="selectedMenuComponent.component" class="nd-tab-con">
          <component
            v-bind="selectedMenuComponent.componentProps"
            v-on="selectedMenuComponent.componentEvent"
            :is="selectedMenuComponent.component"
          />
        </div>
      </div>
    </div>
  </ModalNewDesign>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import SelfServiceUserEdit from '@/components/self-service/user/SelfServiceUserEdit.vue';
import SelfServiceUserManage from '@/components/self-service/user/SelfServiceUserManage.vue';
import ModalNewDesign from '@/components/shared/composite/ModalNewDesign.vue';
import { useSubscriptionStore } from '@/stores/subscription';
import { useUserStore } from '@/stores/user';
import { TypeUser } from '@/types/common';
import { SelfServiceSettingMenu } from '@/types/components';

const props = withDefaults(
  defineProps<{
    menu: SelfServiceSettingMenu;
  }>(),
  {
    menu: 'PROFILE',
  }
);
const emit = defineEmits<{ close: [] }>();

const userStore = useUserStore();
const subscriptionStore = useSubscriptionStore();

const { t } = useI18n();

const selectedMenu = ref<SelfServiceSettingMenu>(props.menu);

const selectedMenuComponent = computed(() => {
  const component = items.value.find((item) => selectedMenu.value === item.value);
  return (
    component || {
      component: null,
      componentProps: {},
      componentEvent: {},
    }
  );
});

const userType = computed<TypeUser>(() => {
  const { userType = '' } = userStore.userInfo || {};
  return userType;
});

const currentPlan = computed(() => {
  return subscriptionStore.currentPlan;
});

const items = computed(() => [
  {
    label: t('label_edit_my_info'),
    value: 'PROFILE',
    component: SelfServiceUserEdit,
    componentProps: { domain: 'SELF_SERVICE' },
    componentEvent: {
      close: closeModal,
    },
    accessUserTypes: ['HOST', 'SUB'],
    accessPlanTypes: [],
  },
  {
    label: t('label_extra_users'),
    value: 'EXTRA_USERS',
    component: SelfServiceUserManage,
    accessUserTypes: ['HOST'],
    accessPlanTypes: ['STARTER', 'PRO', 'ENTERPRISE'],
  },
]);

const isVisibleMenu = (item): boolean => {
  return (
    item.accessUserTypes.includes(userType.value) &&
    (item.accessPlanTypes.length === 0 || item.accessPlanTypes.includes(currentPlan.value))
  );
};

const handleMenu = (menu: SelfServiceSettingMenu) => {
  selectedMenu.value = menu;
};

const closeModal = () => {
  emit('close');
};
</script>

<style scoped lang="scss">
.nd-tab-con {
  overflow: auto;
}
</style>
